import { apiBusSchedBaseURL } from '../../authentication/Global';
import { apiSchematicMapBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class DataUpdateAPI {
    constructor(appName) {
        switch (appName) {
            case "bussched":
                this.baseUrl = new URL("bussched/dataupdates/", apiBusSchedBaseURL);
                break;
            case "schematicmap":
                this.baseUrl = new URL("schematicmap/dataupdates/", apiSchematicMapBaseURL);
                break;
            default:
                this.baseUrl = new URL("");
                break;
        }
    }

    list(networkEdition) {
        return API.authenticatedRequest({
            url: new URL(`${networkEdition}`, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
        });
    }
}